/* eslint-disable */

import Vue from "vue";
import Router from "vue-router";
import Tutorial from "@/components/Tutorial";
import CriarPosts from "@/components/CriarPosts";
import EditarPosts from "@/components/EditarPosts";
import ListarPosts from "@/components/ListarPosts";
import VisualizarPosts from "@/components/VisualizarPosts";
import Login from "@/components/Login";
import Registrar from "@/components/Registrar";
import Noticia from "@/components/Noticia";
import Inicio from "@/components/Inicio";
import Orcamento from "@/components/Orcamento";
import Parceiros from "@/components/Parceiros";
import AreaCliente from "@/components/AreaCliente";
import Servicos from "@/components/Servicos";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/inicio",
      name: "Inicio",
      component: Inicio
    },
    {
      path: "/orcamento",
      name: "Orcamento",
      component: Orcamento
    },
    {
      path: "/cliente",
      name: "AreaCliente",
      component: AreaCliente
    },
    {
      path: "/parceiros",
      name: "Parceiros",
      component: Parceiros
    },
    {
      path: "/servicos",
      name: "Servicos",
      component: Servicos
    },
    {
      path: "/noticias",
      name: "VisualizarPosts",
      component: VisualizarPosts
    },
    {
      path: "/noticia/:id",
      name: "Noticia",
      component: Noticia
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/registrar",
      name: "Registrar",
      component: Registrar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tutorial",
      name: "Tutorial",
      component: Tutorial,
      meta: {
        requiresAuth: true
      }
    },
    { path: "/", redirect: "/inicio" },
    {
      path: "/listar",
      name: "ListarPosts",
      component: ListarPosts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/criar",
      name: "CriarPosts",
      component: CriarPosts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/editar/:id",
      name: "EditarPosts",
      component: EditarPosts,
      meta: {
        requiresAuth: true
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("usertoken") == null) {
      next({
        path: "/login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js